<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {};
  },
  watch: {},
  created() {

  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
<style>
  #parkParkingSpace .el-table--small td, #parkParkingSpace .el-table--small th {
    padding: 0 !important;
  }
  .car-park-base-info-dia .el-tabs__item {
    padding: 0 10px;
  }
.el-input__inner[disabled="disabled"]{
   background-color: #eee !important;
}
.el-textarea__inner[disabled="disabled"]{
  background-color: #eee !important;
}
.el-image-viewer__btn{
  color: #409EFF !important;
}
.el-tooltip__popper {
    max-width: 240px !important; 
}
.el-dialog__body{
  padding: 20px !important;
}
.el-input__inner{
  height: 32px;
  line-height: 32px !important;
}
.el-form-item__content{
        line-height: 32px !important;
}
.el-form-item__label{
  line-height: 32px !important;
}
</style>
